'use client';

var translations = {
    Search: 'Tìm kiếm',
    Cancel: 'Hủy',
    'No result': 'Không có kết quả',
    'Job Function': 'Ngành nghề',
    'All job function': 'Ngành nghề',
    'Select job function.': 'Hãy chọn nghề nghiệp chuyên môn.',
    'Remove all': 'Xóa tất cả',
    All: 'Tất cả'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
